import React from "react";
import { observer } from "mobx-react";
import { Link, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import { useHistory } from "react-router";
import moment from "moment";
import { Order, OrderStatus } from "../../../../../../../../services/orders/models";
import { EnhancedTableHead, HeadCell } from "../../../../../../../../common/components/TableHelpers";
import { useStores } from "../../../../../../../../hooks";
import { PaymentProviderType } from "../../../../../../../../services/general/models";
import { useTranslation } from "react-i18next";
import { BookingOrder } from "../../../../../../../../services/bookingOrders/models";


const isOnline = (order: BookingOrder) => {
    const onlinePayments = [PaymentProviderType.cloudpayments, PaymentProviderType.sbpTochka];
    return onlinePayments.indexOf(order.paymentDetails.type) >= 0
}
const OrdersTable = ({ orders }: { orders: BookingOrder [] }) => {
    const { generalStore, constantsStore } = useStores();
    const { t} = useTranslation(["general", "bookings"]);
    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);
    const history = useHistory();
    const navigateTo = (orderId: number) => {
        history.push(`/stats/bookings/${orderId}/view`);
    };

    const headCells: Array<HeadCell> = [
        { id: 'id', alignment: 'left', label:  t("general:number") },
        { id: 'date', alignment: 'left', label: t("general:date") },
        { id: 'amount', alignment: 'left', label: t("orders:sum") },
        { id: 'paymentType', alignment: 'left', label: t("orders:paymentType") },
        { id: 'paymentStatus', alignment: 'left', label: t("orders:paymentState") },
        { id: 'status', alignment: 'left', label: t("orders:orderState")},
        { id: 'check', alignment: 'left', label: t("orders:check")}
    ];

    return(
        <Paper>
            <TableContainer>
                <Table
                    aria-labelledby="tableTitle"
                    size={"medium"}
                    aria-label="enhanced table"
                >
                    <EnhancedTableHead cells={headCells}/>
                    <TableBody>

                        {orders.map((row, index: number) => {
                            return (
                                <TableRow
                                    hover
                                    tabIndex={-1}
                                    key={`${row.id}-${index}`}
                                    onClick={() => {
                                        navigateTo(row.id);
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    <TableCell align="left">
                                        {row.id}
                                    </TableCell>
                                    <TableCell align="left">
                                        {moment(row.createdAt).format("DD.MM.YYYY HH:mm")}
                                    </TableCell>
                                    <TableCell align="left">
                                        {currencyFormatter.toShowFormatted(row.totalPrice.price)}
                                    </TableCell>


                                    <TableCell align="left">
                                        {t(`bookings:paymentProviderType.${row.paymentDetails.type}`)}
                                    </TableCell>

                                    {(!row.paymentDetails.isPaid && row.status !== OrderStatus.canceledWithRefund && isOnline(row)) &&
                                    <TableCell align="left" style={{ color: "#f57c00" }}>
                                        {t("bookings:notPaid")}
                                    </TableCell>
                                    }
                                    {(row.paymentDetails.isPaid && row.status !== OrderStatus.canceledWithRefund && isOnline(row)) &&
                                    <TableCell align="left" style={{ color: "#388e3c" }}>
                                        {t("bookings:paid")}
                                    </TableCell>
                                    }
                                    {(row.status !== OrderStatus.canceledWithRefund && row.paymentDetails.type === PaymentProviderType.companyInvoice || row.paymentDetails.type === PaymentProviderType.offline || row.paymentDetails.type === PaymentProviderType.toBankCard) &&
                                    <TableCell align="left">
                                      -
                                    </TableCell>
                                    }
                                    {(row.status === OrderStatus.canceledWithRefund) &&
                                    <TableCell align="left" style={{ color: "#dc004e" }}>
                                        {t("bookings:return")}
                                    </TableCell>
                                    }

                                    <TableCell align="left">
                                        {t(`bookings:orderStatus.${row.status}`)}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.paymentDetails.receiptLink ?
                                            <Link href={row.paymentDetails.receiptLink} variant="body2">
                                                {t("bookings:check")}
                                            </Link> :
                                            <p>-</p>
                                        }
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default observer(OrdersTable);
